export default class{
    constructor(node){
        this.x=0;
        this.y=0;
        this.getMposi(node);
    }
getMposi(node){
    let posx = 0;
    let posy = 0;
    var e = window.event;   //mouse event can be gotten 
    if (e.pageX || e.pageY)     {
        posx = e.pageX;
        posy = e.pageY;
    }
    else if (e.clientX || e.clientY)    {
        posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
     const posi = this.getRelativePos(posx,posy,node)
     this.x= posi.x;this.y=posi.y;  
         return;
     }
getRelativePos(posx,posy,node){
        const docScrolls = {left : document.body.scrollLeft + document.documentElement.scrollLeft, top : document.body.scrollTop + document.documentElement.scrollTop};
const bounds = node.getBoundingClientRect();//対象要素の情報取得
return {
    x : posx - bounds.left - docScrolls.left,
    y : Math.ceil(posy - bounds.top - docScrolls.top)}
    }
}   